import { isProjectSuspended } from '@/modules/projects/projectLifecycle';
export function assignedOpenTasks(responses, userId) {
	if (userId == null) return [];

	return responses
		.reduce((tasks, response) => tasks.concat(response.data || []), [])
		.filter(
			(task) =>
				task &&
				task.archived !== true &&
				!isProjectSuspended(task.project) &&
				!task.completed &&
				(task.assignedToList || []).some((assignedTo) => String(assignedTo) === String(userId))
		)
		.sort((a, b) => (a.dueDate || '9999-12-31').localeCompare(b.dueDate || '9999-12-31'));
}

export function openTicketsForUser(tickets, userId, email) {
	const normalizedEmail = (email || '').toLowerCase();

	return (tickets || []).filter(
		(ticket) =>
			ticket.open !== false &&
			((userId != null &&
				(String(ticket.clientContactId) === String(userId) ||
					(ticket.assignedTo || []).some((assignedTo) => String(assignedTo) === String(userId)))) ||
				(normalizedEmail && (ticket.ccList || []).some((cc) => cc.toLowerCase() === normalizedEmail)))
	);
}
